import React from 'react';
import { List, DateField, Datagrid, ReferenceField, TextField, EditButton, EmailField } from 'react-admin';
// import RichTextInput from 'ra-input-rich-text';
import Icon from '@material-ui/icons/LocalOffer';
import ImageGridField from 'components/ImageGridField';
import EditForm from './EditForm';
import CreateForm from './CreateForm';

export const PromotionIcon = Icon;

export const PromotionList = props => (
  <List {...props}>
    <Datagrid>
      <ImageGridField source="cover_url" title="title" label="Cover Image" />
      <TextField source="title" />
      <ReferenceField
        label="Car Brand"
        sortBy="car_brands.name"
        source="car_brand_id"
        reference="brands"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Car Model"
        sortBy="car_models.name"
        source="car_model_id"
        reference="models"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="started_at" label="Start Date" />
      <DateField source="ended_at" label="End Date" />
      <TextField source="contact_mobile" />
      <EmailField source="contact_email" />
      <EditButton />
    </Datagrid>
  </List>
);

export const PromotionCreate = CreateForm;

export const PromotionEdit = EditForm;



// WEBPACK FOOTER //
// ./src/containers/Promotion/index.js